import { createSearchParams } from 'react-router-dom';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { IProduct } from '../../interfaces/Product.interfaces';
import { String } from 'lodash';

const getBaseProductDetailPageURL = (path: string, additionalPath: string): string => {
  return `${path}/${additionalPath}`;
};

export const getOpenMarketDetailPageURL = (id: string): string => {
  if (!id) {
    return '';
  }
  const openMarketDetailPagePath = pageInfo.openMarketDetailPage.path;
  return getBaseProductDetailPageURL(openMarketDetailPagePath, id);
};

export const getGeneralMarketDetailPageURL = (product: IProduct): string => {
  const searchParam = { category: product.category };
  const urlSearchParams = createSearchParams(searchParam).toString();
  const queryParams = urlSearchParams ? `?${urlSearchParams}` : '';
  const productDetailPagePath = pageInfo.productDetailPage.path;
  return getBaseProductDetailPageURL(productDetailPagePath, product.id) + queryParams;
};
